import { AvvirEvent } from "type_aliases";
import { FloorTradeBuiltElementCounts } from "../../../services/reducers/domain/reduce_floor_trade_built_element_counts";

export type FloorTradeBuiltElementCountsLoadedEvent = AvvirEvent<typeof FLOOR_TRADE_BUILT_ELEMENT_COUNTS_LOADED, {
  projectId: string,
  builtElementCounts: FloorTradeBuiltElementCounts
}>

const floorTradeBuiltElementCountsLoaded = (projectId: string, builtElementCounts: FloorTradeBuiltElementCounts): FloorTradeBuiltElementCountsLoadedEvent => ({
  type: FLOOR_TRADE_BUILT_ELEMENT_COUNTS_LOADED,
  payload: {
    projectId,
    builtElementCounts
  }
});

export const FLOOR_TRADE_BUILT_ELEMENT_COUNTS_LOADED = "floor_trade_built_element_counts_loaded";

export default floorTradeBuiltElementCountsLoaded;
